import React, {useCallback, useMemo, useRef, useState} from "react";
import Size from "@/util/Size.ts";
import {ResponsiveStageContext, ResponsiveStageReturn} from "@/components/konva/stage/ResponsiveStageHooks.ts";
import Konva from "konva";

interface ResponsiveStageProviderProps {
    children: React.ReactNode,
}

export function ResponsiveStageProvider({children}: ResponsiveStageProviderProps) {
    const stageRef = useRef<Konva.Stage>(null);
    const [stageSize, setStageSize] = useState<Size>({width: 800, height: 600});
    const [stageMeasured, setStageMeasured] = useState(false);

    const updateStageSize = useCallback((size: Size) => {
        setStageSize(currentSize =>
            currentSize.width === size.width && currentSize.height === size.height
                ? currentSize
                : size
        );
        setStageMeasured(true);
    }, []);

    const returnValue = useMemo<ResponsiveStageReturn>(
        () => ({
            stageRef,
            stageSize,
            stageMeasured,
            setStageSize: updateStageSize,
        }),
        [
            stageSize,
            stageMeasured,
            updateStageSize,
        ]
    );

    return (
        <ResponsiveStageContext.Provider value={returnValue}>
            {children}
        </ResponsiveStageContext.Provider>
    )
}
